<div class="row align-items-center">
	<div style="width: 93%;">
		<input
			[hidden]="addressEditing"
			type="text"
			name="code_name"
			id="code_name"
			class="form-control"
			[ngModel]="localizationStr"
			[ngStyle]="{
				'border-color': localization && localization.geocoded ? 'lightgreen' : 'red'
			}"
			placeholder="{{ 'administration.customers.geocodedNotOK' | translate }}" 
			[style]="{ width: '100%', height: '60px' }"
			pTooltip="{{ localization && localization.geocoded ? tooltipMessage2 : tooltipMessage1 }}"
			tooltipPosition="top"
			disabled="true"
		/>
		<cercalia-autocomplete
			#cercaliaAutocompleteId
			[hidden]="!addressEditing"
			style="text-align: start"
			[style]="{ 'font-style': 'Gotham !important' }"
			class="form-control"
			id="{{ autoCompleteId }}"
			pTooltip="{{ tooltipMessage3 }}"
			tooltipPosition="top"
		>
		</cercalia-autocomplete>
	</div>
	<div style="width: 7%;">
		<button
			*ngIf="!addressEditing"
			pButton
			pRipple
			type="button"
			icon="pi pi-pencil"
			(click)="onAddressEditInit()"
			class="p-button-rounded p-button-text  "
		></button>
		<button
			*ngIf="!addressEditing && canDelete"
			pButton
			pRipple
			type="button"
			icon="pi pi-trash"
			(click)="onAddressDelete()"
			style="color: red;"
			class="p-button-rounded p-button-text p-button-trash  "
		></button>
		<button
			*ngIf="addressEditing"
			pButton
			pRipple
			type="button"
			icon="pi pi-times"
			(click)="onAddressEditCancel()"
			class="p-button-rounded p-button-text p-button-danger"
		></button>
	</div>
</div>
<!--    class="custom-cercalia-autocomplete"  [attr.id]="cercaliaAutocompleteId2"  -->
